export default function createPublicPathReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'RESTART_PHP_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'RESTART_PHP_ERROR':
            return {...state, ...{error: action.error}};

        case 'RESTART_PHP_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}